import { setCookie, getCookie } from "../functions/cookies";

const closeButtonTemplate = `<button class="close-btn" type="button" title="schließen"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M17.576 13.455c.283.282.424.626.424 1.03s-.141.747-.424 1.03l-2.06 2.06a1.403 1.403 0 0 1-1.031.425 1.4 1.4 0 0 1-1.03-.424L9 13.12l-4.455 4.455a1.403 1.403 0 0 1-1.03.424c-.404 0-.747-.141-1.03-.424l-2.06-2.06A1.403 1.403 0 0 1 0 14.484a1.4 1.4 0 0 1 .424-1.03L4.88 9 .424 4.545A1.403 1.403 0 0 1 0 3.515c0-.404.141-.747.424-1.03l2.06-2.06A1.403 1.403 0 0 1 3.516 0a1.4 1.4 0 0 1 1.03.424L9 4.88 13.455.424A1.403 1.403 0 0 1 14.485 0c.404 0 .747.141 1.03.424l2.06 2.06c.284.284.425.627.425 1.031a1.4 1.4 0 0 1-.424 1.03L13.12 9l4.455 4.455Z"/></svg></button>`;
const footer = document.querySelector("footer");
const disruptor = document.querySelector(".ce_distruptor");
const layout2 = document.querySelector(".ce_distruptor .layout-2");

const updateBottomBar = () => {
  let bottomBarHeight = layout2.offsetHeight;
  footer.style.paddingBottom = bottomBarHeight + "px";
};

const updateLayout2Pos = () => {
  let windowWidth = window.innerWidth;
  let introBoxRect = document
    .querySelector(".intro-box")
    .getBoundingClientRect();

  layout2.classList.remove("bar");
  layout2.classList.remove("relative");
  disruptor.style.height = "";
  layout2.style.left = "";
  footer.style.paddingBottom = "";

  if (windowWidth > 1200) {
    disruptor.style.height = "0";
    layout2.style.left = introBoxRect.right + "px";
  } else if (windowWidth > 992) {
    layout2.classList.add("relative");
  } else {
    layout2.classList.add("bar");
    updateBottomBar();
  }
};

const updateLayout2SidePos = () => {
  let windowWidth = window.innerWidth;
  let headerRect = document
    .querySelector(".page-header")
    .getBoundingClientRect();

  layout2.classList.remove("bar");
  layout2.classList.remove("side");
  layout2.style.top = "";
  footer.style.paddingBottom = "";

  if (windowWidth > 1400) {
    layout2.classList.add("side");
    layout2.style.top = headerRect.height + 65 + "px";
  } else {
    layout2.classList.add("bar");
    updateBottomBar();
  }
};

export const init = () => {
  let attempts = 0;

  if (layout2) {
    layout2.innerHTML = closeButtonTemplate + layout2.innerHTML;
    let disruptor2Closed = getCookie("disruptor2Closed");
    if (!disruptor2Closed) layout2.classList.add("show");

    if (document.querySelector(".intro-box")) {
      updateLayout2Pos();
    } else {
      updateLayout2SidePos();
    }
  }

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      const closeBtn = layout2.querySelector(".close-btn");

      if (layout2) {
        window.addEventListener("resize", (e) => {
          let windowWidth = window.innerWidth;
          if (document.querySelector(".intro-box")) {
            updateLayout2Pos();
          } else {
            updateLayout2SidePos();
          }
          if (windowWidth >= 991) updateBottomBar();
        });

        if (closeBtn) {
          closeBtn.addEventListener("click", () => {
            setCookie("disruptor2Closed", "true", 30); // 30 Sekunden
            // setCookie("disruptor2Closed", "true", 604800); // 7 Tage
            layout2.classList.remove("show");
          });
        }
      }
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
